// import styles from "./style";
// import { Billing, Business, Clients, CTA, Footer, Navbar, Stats, Testimonials, Hero } from "./components";
// import AIHiringProcess from "./components/AIHiringProcess";
// import { useEffect } from "react";



// const App = () => 
  
  
  
//   {
//   // <div className="bg-primary w-full overflow-hidden">
//   //   <div className={`${styles.paddingX} ${styles.flexCenter}`}>
//   //     <div className={`${styles.boxWidth}`}>
//   //       <Navbar />
//   //     </div>
//   //   </div>

//   //   <div className={`bg-primary ${styles.flexStart}`}>
//   //     <div className={`${styles.boxWidth}`}>
//   //       <Hero />
//   //     </div>
//   //   </div>
    
//   //   <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
//   //     <div className={`${styles.boxWidth}`}>
//   //       {/* <Stats /> */}
//   //       <Business />
//   //       <Billing />
//   //       <AIHiringProcess />
//   //       <Testimonials />
//   //       <Clients />
//   //       <CTA />
//   //       <Footer />
//   //     </div>
//   //   </div>
//   // </div>

//   <>
  
//   </>

//   }
// );

// export default App;

import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    window.location.href = "https://www.prompthire.ai"; 
  }, []);

  return null; 
};

export default App;